import React, { useEffect, useState } from "react";
import CookieIcon from "@mui/icons-material/Cookie";
import { Button } from "../Button/Button";
import * as S from "./Styles";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check localStorage for dismissal state
    const isDismissed = localStorage.getItem("cookieNoticeDismissed");
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // Save dismissal state in localStorage
    localStorage.setItem("cookieNoticeDismissed", "true");
  };

  if (!isVisible) return null;

  return (
    <S.Container>
      <S.Content>
        <S.TitleContainer>
          <CookieIcon style={{ width: "32px", height: "32px" }} />
          <S.Title>Informasjonskapsler</S.Title>
        </S.TitleContainer>
        <S.Body>
          <S.BodyText>Denne siden bruker informasjonskapsler (cookies) for å forbedre brukeropplevelsen.</S.BodyText>
          <S.BodyText>
            Vi samler inn helt anonym data om hvordan du bruker siden vår, slik at vi kan forbedre den. Dette blir ikke
            delt med noen andre.
          </S.BodyText>
        </S.Body>
        <Button onClick={handleClose} text="Den er grei!" />
      </S.Content>
    </S.Container>
  );
};

export default CookieBanner;
